<template>
    <v-container fluid class="container-full-bg-gray">   
        <div style="background-color: rgb(237 237 237); width: 100%; height: 100%; box-sizing: border-box;padding: 15px;">
            <div style="background-color: rgb(255 255 255); width: 100%; min-height: 300px; border-radius: 20px;">
                <div style="padding: 15px 35px;">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <div style="color: var(--v-primary-base); font-weight: 500;font-size: 1.25rem;">{{$t("Connector2List.companies")}}</div>
                        <div style="display: flex; justify-content: flex-end; gap: 10px;">
                            <v-tooltip top>
                                <template v-slot:activator="{on, attrs}">
                                    <v-btn icon color="var(--v-primary-base)" @click="refreshList()" v-on="on" v-bind="attrs">
                                        <v-icon>mdi-refresh</v-icon>
                                    </v-btn>
                                </template>
                                <span>Refresh</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{on, attrs}">
                                    <v-btn icon color="var(--v-primary-base)" @click="showCreateCompany()" v-on="on" v-bind="attrs">
                                        <v-icon>mdi-domain-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Crear empresa</span>
                            </v-tooltip>
                            <GenericWarningPopUp
                                v-if="show_warn_pop_up"
                                v-model="show_warn_pop_up"
                                title="Algo ha ido mal"
                                :description="error_message"
                                ></GenericWarningPopUp>
                            <PopUpSimpleCompany
                                v-if="show_popup"
                                :company="selected_company"
                                :extra_fields="extra_fields"
                                :show="show_popup"
                                @save="saveCompany"
                                @cancel="cancelEdit"
                                :loading="loadingSave"
                            />
                            <!-- Menu de Acciones -->
                            <!-- <v-menu
                                v-model="menu_visible"
                                :close-on-content-click="false"
                                offset-y
                                transition="scale-transition"
                            >
                                <template v-slot:activator="{on,attrs}">
                                    <v-btn
                                        :disabled="!isButtonActive()"
                                        outlined
                                        :class="buttonClass()"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        ACCIONES
                                        <v-icon v-if="isButtonActive()">mdi-menu-down</v-icon>
                                        <v-icon v-else>mdi-menu-up</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                        v-for="action in actions"
                                        :key="action.name"
                                        @click="handleAction(action)"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title>{{action.name}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu> -->
                        </div>
                    </div>
                </div>
                <hr style="width: 100%; height: 1px; background-color: rgba(0, 0, 0, 0.05); border: none;" />
                <!-- Lista de Empresas -->
                <div style="padding: 20px 35px;">
                    <template>
                        <!-- show-select <-mostrar checkboxs -->
                        <v-data-table
                            v-model="selected_option"
                            :headers="headers"
                            :items="companies"
                            item-value="id"
                            :footer-props="{
                                'items-per-page-options': [5, 10, 50, 100, 200, 500],
                                'items-per-page-text': 'Empresas por página:',
                            }"
                            class="custom-table"
                            @click:row="selectRow"
                            :loading="loadingTable"
                        > 
                            <!-- headers -->
                            <template #header.id="{item}">
                                {{ $t("Connector2List.id") }}
                            </template>
                            <template #header.name="{item}">
                                {{ $t("Connector2List.name") }}
                            </template>
                            <template #header.cif="{item}">
                                {{ $t("Connector2List.cif") }}
                            </template>

                            <!-- list -->
                            <template #item.id="{item}">
                                <div>
                                    {{ item.id }}
                                </div>
                            </template>
                            <template #item.nombre="{item}">
                                <div>
                                    {{ item.name }}
                                </div>
                            </template>
                            <template #item.cif="{item}">
                                <div>
                                    {{ item.cif }}
                                </div>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex"
import { query_dispatcher, sync_command_dispatcher, async_command_dispatcher} from "@/api/client";
//import PopupCreateCompany from '@/components/PopupCreateCompany.vue';
import PopUpSimpleCompany from '../modules/company/infra/PopUpSimpleCompany.vue';
import GenericWarningPopUp from "@/modules/shared/infra/GenericWarningPopUp.vue";
export default {
    name: "Connector2List",
    components: {
        PopUpSimpleCompany,
        GenericWarningPopUp
    },
    data() { 
        return {
            selected_option: [],
            selected_companies: [],
            menu_visible: false,
            actions: [
                { name: 'Crearrrrrrrrrrr' },
                { name: 'Borrarrrrrrrrrr' }
            ],
            companies: [],
            headers: [
                { text: "Id", value: "id", align: 'start'},
                { text: "Nombre", value: "name", align: 'start'},
                { text: "CIF", value: "cif", align: 'start'}
            ],
            select_all: false,
            show_popup: false,
            selected_company: null,
            extra_fields:[],
            show_warn_pop_up: false,
            error_message: "",
            loadingTable: false,
            loadingSave: false,
        }
    },
    computed: {
        ...mapGetters({userData: 'me/userData',}),
    },
    methods: {
        selectRow(item) {
            this.selected_company = item
            console.log("Selected company:", this.selected_company)
            this.show_popup = true
        },
        async saveCompany(val){
            console.log(val)
            this.loadingSave = true
            let res = await sync_command_dispatcher.dispatch("save.simple.company", {
                company_id: val.id,
                cif: val.cif,
                name: val.name,
                custom_fields: val.custom_fields || {}
            })
            if (res.output && res.output.error){
                this.show_warn_pop_up = true
                this.error_message = res.output.error
            }
            this.loadingSave = false
            this.show_popup = false

            this.refreshList()
        },
        cancelEdit() {
            this.show_popup = false
        },
        handleSelectedCompanies() {
            console.log("aaaaaa", this.selected_companies)
        },
        isButtonActive() {
            return this.selected_companies.length > 0;
        },
        buttonClass() {
            return this.selected_companies.length > 0 ? 'buttonActive' : 'buttonNoActive';
        },
        emptySelectedCompanies() {
            this.selected_companies = []
        },
        toggleSelectAll() {
            if (this.select_all) {
                this.selected_companies = this.companies.map(company => company.id);
            } else {
                this.selected_companies = [];
            }
        },
        handleClosePopup(value) {
            this.selected_company = null
            this.show_popup = false
            this.refreshList()
        },
        showCreateCompany() {
            this.show_popup = true
        },
        async refreshList() {
            this.loadingTable = true
            await this.getCompaniesByUser()
            this.loadingTable = false
        },
        async getCompaniesByUser(){
            console.log("Consiguiendo empresas de usuario")
            try {
                this.companies = await query_dispatcher.dispatch("show.user.companies", {})
                // this.companies =
                console.log("Empresas conseguidas con exito")
            } catch(error) {
                console.error("Error al conseguir empresa: ",error)
            }
        },
        async getExtraFields() {
            console.log("Consiguiendo campos extra de empresa")
            try {
                this.extra_fields = await query_dispatcher.dispatch("get.setting", {"setting_code": "custom_simple_company_fields", "setting_user_id": this.userData.id})
                console.log("Campos extra conseguidos con exito")
            } catch(error) {
                this.extra_fields = []
                console.error("Error al conseguir campos extra de empresa: ",error)
            }
        },
    },
    mounted() {
        console.log("yooo", this.userData)
        this.getCompaniesByUser()
        this.getExtraFields()
    }
}
</script>

<style scoped>
.buttonActive {
    color: var(--v-primary-base);
    border-color: var(--v-primary-base);
    background-color: white;
}
.buttonNoActive {
    color: #adadad;
    border-color: #adadad;
    background-color: white;
}
.custom-table >>> .v-data-table-header th {
    background-color: rgb(235 234 255) !important;
    color: rgb(102 53 155) !important;
    font-size: .875rem;
}
.scroll-container {
    overflow-y: auto;
}
.center {
    display: flex;
    align-items: center;
}
</style>